// extracted by mini-css-extract-plugin
export default {"logoCompany":"LogoCompany_logoCompany__gU8X9","logoText":"LogoCompany_logoText__gDtZp"};